<template>
  <div class="header-actions">
    <button class="btn btn-danger" @click="deleteDescriptions"><i class="fa fa-trash" aria-hidden="true"></i> Dzēst uz dzēšanu atzīmētos aprakstus</button>
  </div>
</template>

<script>
export default{
  data(){
    return {

    }
  },
  methods:{
    deleteDescriptions()
    {
      var that = this;
      that.$swal.fire({
        title: 'Vai tiešām vēlaties dzēst visus uz dzēšanu atzīmētos zinātniskos aprakstus?',
        text: "Šo darbību nebūs iespējams atsaukt.",
        icon: 'error',
        showCancelButton: true,
        confirmButtonColor: '#E53935',
        cancelButtonColor: '#888787',
        confirmButtonText: 'Dzēst',
        cancelButtonText: 'Atcelt'
      }).then((result) => {
        if (result.value) {
          axios.post('/dashboard/api/scientific-descriptions/delete')
              .then(response => {
                if(response.data.status == 'ok')
                {
                  EventBus.$emit('scientific_descriptions_deleted');
                  that.$toast.open(response.data.message);
                }
              });
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>

.header-actions{
  margin-left:auto;
}


</style>